<template>
  <v-select
    :id="inputId"
    :value="value"
    @input="$emit('input', $event)"
    :options="options"
    :filterable="false"
    @search="onSearch"
    :loading="isLoading"
    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    class="w-100"
    append-to-body
    :calculate-position="withPopper"
    :reduce="reduce"
    :multiple="multiple"
    :disabled="disabled"
  >
    <template #option="slotProps">
      <slot name="option" v-bind="slotProps">
        {{ slotProps.label }}
      </slot>
    </template>
    <template #list-footer>
      <li class="pagination">
        <b-button
          variant="outline-primary"
          size="sm"
          :disabled="!hasPrevPage"
          @click="currentPage--"
          :style="{
            cursor: hasPrevPage ? 'pointer' : 'not-allowed',
            backgroundColor: hasPrevPage ? null : '#e7e9eb',
          }"
        >
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </b-button>
        <b-button
          variant="outline-primary"
          size="sm"
          :disabled="!hasNextPage"
          @click="currentPage++"
          :style="{
            cursor: hasNextPage ? 'pointer' : 'not-allowed',
            backgroundColor: hasNextPage ? null : '#e7e9eb',
          }"
        >
          <feather-icon icon="ChevronRightIcon" size="18" />
        </b-button>
      </li>
    </template>
  </v-select>
</template>

<script>
import vSelect from "vue-select";
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import axios from "@/libs/axios";
import { debounce } from "lodash";
import popperHelper from "@/libs/popper-helper";

const initialMeta = {
  last_page: 1,
  current_page: 1,
};

export default {
  components: {
    vSelect,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    inputId: {
      type: String,
      default: "select-id",
    },
    value: {
      default: null,
    },
    url: {
      type: String,
    },
    reduce: {
      type: Function,
      default: (val) => val,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    reduce: {
      type: Function,
      default: (val) => val,
    },
    optionMapper: {
      type: Function,
      default: (val) => val,
    },
  },
  setup(props) {
    const search = ref("");
    const options = ref([]);
    const isLoading = ref(true);
    const currentPage = ref(1);
    const optionSelected = ref(null);

    const meta = ref(initialMeta);

    const getUserOptions = () => {
      isLoading.value = true;

      axios
        .get(props.url, {
          params: {
            max: props.perPage,
            "page[n]": currentPage.value,
            q: search.value,
          },
        })
        .then((response) => {
          options.value = response.data.data.map(props.optionMapper);

          meta.value = response.data.meta;
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const onSearch = (query) => {
      search.value = query;
    };

    watch(currentPage, () => {
      getUserOptions();
    });

    watch(
      search,
      debounce(() => {
        currentPage.value = 1;
        getUserOptions();
      }, 500)
    );

    const hasNextPage = computed(() => {
      return meta.value.current_page < meta.value.last_page;
    });

    const hasPrevPage = computed(() => {
      return meta.value.current_page > 1;
    });

    onMounted(() => {
      getUserOptions();
    });

    return {
      optionSelected,
      options,
      search,
      hasNextPage,
      hasPrevPage,
      currentPage,
      onSearch,
      isLoading,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>

<style>
.vs--disabled {
  cursor: not-allowed;
}

.vs--disabled * {
  cursor: not-allowed;
}
</style>
<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
}
.pagination button:hover {
  cursor: pointer;
}
</style>

